/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateChangeProposalRequest} from '@cash-web/protos/squareup/timecards/timecards_service.pb'
import {CreateChangeProposalResponse} from '@cash-web/protos/squareup/timecards/timecards_service.pb'


export const createChangeProposal = (request: CreateChangeProposalRequest, options?: CashRequestOptions) => post<CreateChangeProposalRequest, CreateChangeProposalResponse>("/proxy/services/squareup.timecards.PublicTimecardsService/CreateChangeProposal", request, {...options, rejectOnError: true })